import { FC, Suspense } from "react";
import { RouterProvider } from "@tanstack/react-router";
import { router } from "./router";
import { SuspenseLoader } from "@shared/ui/Loader";
import { ToastManager } from "@features/toasts/ToastManager";

const App: FC = () => {
  return (
    <Suspense fallback={<SuspenseLoader />}>
      <RouterProvider router={router} />
      <ToastManager />
    </Suspense>
  );
};

export default App;
